export default __webpack_public_path__ + "static/warehouse-85a1cf77aae614ece7a447fea8e9a665.png";